var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SparklesIcon } from '@heroicons/react/24/solid';
import { InsightResponseModal } from '@web/components/layout/Modal/InsightResponseModal';
import { IS_DEMO } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { classNames, isInsightsDataEmpty } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { generateQueryFromTable } from '@workalizer/generative-ai/src/lib/generative-ai/utils';
import { getInsightTitle } from '@workalizer/generative-ai/src/lib/generative-ai/utils';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var AIButton = function (_a) {
    var _b;
    var insightsData = _a.insightsData, labels = _a.labels, insightType = _a.insightType, refetch = _a.refetch;
    var t = useTranslation().t;
    var context = useWorkspaceCtx();
    var toast = useToast().toast;
    var filters = useFilters();
    var isDisabled = isInsightsDataEmpty(insightsData);
    var getInsight = trpc.getInsight.useMutation();
    var updateInsight = trpc.updateInsight.useMutation();
    var _c = useState(null), insightResponse = _c[0], setInsightResponse = _c[1];
    var _d = useState(false), isInsightLoading = _d[0], setIsInsightLoading = _d[1];
    var _e = useState(false), isInsightModalVisible = _e[0], setIsInsightModalVisible = _e[1];
    var insightTitleParts = getInsightTitle({
        filters: filters,
        context: context,
        insightType: insightType
    });
    var insightTitle = insightTitleParts.join(' - ');
    var handleGetInsight = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prompt, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsInsightLoading(true);
                    setIsInsightModalVisible(true);
                    if (IS_DEMO) {
                        setInsightResponse({
                            id: 0,
                            response: t('insights.demo.body')
                        });
                        setIsInsightLoading(false);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, generateQueryFromTable(insightsData !== null && insightsData !== void 0 ? insightsData : [], labels !== null && labels !== void 0 ? labels : [], insightType, insightTitle)];
                case 2:
                    prompt = _a.sent();
                    return [4 /*yield*/, getInsight.mutateAsync({
                            prompt: prompt,
                            type: insightType || InsightTypeEnum.data
                        })];
                case 3:
                    result = _a.sent();
                    setInsightResponse(result);
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    toast({
                        title: t('alert.error'),
                        description: t('Error fetching insight:'),
                        variant: 'error',
                        duration: 3000
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsInsightLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx("button", __assign({ onClick: function () { return handleGetInsight(); }, disabled: isInsightLoading || isDisabled, className: classNames('text-indigo-600 h-7 w-7 border-[1px] border-indigo-300 rounded-[4px] p-[2px] shadow-sm hover:bg-indigo-50', isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer') }, { children: _jsx(SparklesIcon, { className: "w-5 h-5" }) })), _jsx(InsightResponseModal, { visible: isInsightModalVisible, onClose: function () { return setIsInsightModalVisible(false); }, title: insightTitle, insights: (_b = insightResponse === null || insightResponse === void 0 ? void 0 : insightResponse.response) !== null && _b !== void 0 ? _b : '', onRefetch: function () {
                    refetch();
                    setInsightResponse(null);
                    handleGetInsight();
                }, onRatingSubmit: function (rating) {
                    (insightResponse === null || insightResponse === void 0 ? void 0 : insightResponse.id) &&
                        updateInsight.mutate({
                            id: insightResponse.id,
                            rating: rating
                        });
                }, isInsightLoading: isInsightLoading, hideInsightActions: IS_DEMO })] }));
};
